import { EMBED_CLOSE_DRAWER } from '@/utils/embedMessageTypes';
import { isEmbed } from '@/utils/isEmbed';

export function closeEmbedDrawer(): boolean {
  if (!isEmbed()) return false;

  window.parent.postMessage({ type: EMBED_CLOSE_DRAWER }, '*');
  return true;
}